import { Box, Button, ButtonProps, ClickAwayListener, MenuItem, MenuList, Popper, Theme } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { Sort } from "@mui/icons-material";
import React, { useState } from "react";

export type CustomMenu_ListOption<T = string | number> = { readonly value: T; readonly name: string };
type ListOptions = readonly CustomMenu_ListOption[];
// TODO: generic for CustomMenu
// type ListOption<T> = { readonly value: T; readonly name: string };
// type Options = ListOption<'newest' | 'oldest'>;
export interface CustomMenuProps {
  style?: React.CSSProperties;
  className?: string;
  allOptions: ListOptions;
  currentOption: CustomMenu_ListOption;
  buttonProps?: ButtonProps;
  /** should return the selected option object */
  onChange: (nextOption: any) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popper: {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: "#242323",
      zIndex: 99999,
      border: "#eee solid 1px",
    },
  })
);

export const CustomSortMenu: React.FC<CustomMenuProps> = ({
  allOptions,
  currentOption,
  onChange,
  style,
  className,
  buttonProps,
}) => {
  const classes = useStyles();
  const [menuOpen, setMenuOpen] = useState(false);
  // const [changedOnce, setChangedOnce] = useState(false);
  const sortButtonRef = React.useRef<HTMLButtonElement>(null);

  const handleMenuBtnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuOpen(!menuOpen);
  };

  const handleClose = () => {
    setMenuOpen(false);
  };

  const handleMenuItemClick = (newSortByOption: CustomMenu_ListOption) => {
    handleClose();
    onChange(newSortByOption);
  };

  const mergedButtonProps: ButtonProps = { variant: "contained", ...buttonProps };

  return (
    <div className={className} style={style}>
      <Button
        {...mergedButtonProps}
        size="small"
        variant="outlined"
        aria-controls="open-custom-sort-menu"
        aria-haspopup="true"
        style={{ textTransform: "none" }}
        onClick={handleMenuBtnClick}
        ref={sortButtonRef}
      >
        <Sort fontSize="small" />
        <Box component="span" sx={{ paddingRight: 1, fontWeight: "bold", letterSpacing: 0.5 }}>
          &nbsp;{currentOption.name}
        </Box>
      </Button>

      <Popper
        open={menuOpen}
        anchorEl={sortButtonRef.current}
        className={classes.popper}
        // sx={{
        //   borderRadius: (t) => t.shape.borderRadius,
        //   backgroundColor: "#242323",
        //   zIndex: 99999,
        //   border: "#eee solid 1px",
        // }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList>
            {allOptions.map((sortOption) => (
              <MenuItem
                key={`__CUSTOM_MENU_${sortOption.value}__`}
                dense
                sx={{
                  padding: (t) => t.spacing(0.5, 2),
                  color: currentOption.value === sortOption.value ? "#0096FF" : "#c5c5c5",
                  textAlign: "center",
                  justifyContent: "center",
                  fontWeight: currentOption.value === sortOption.value ? (t) => t.typography.fontWeightBold : undefined,
                }}
                onClick={() => handleMenuItemClick(sortOption)}
              >
                {sortOption.name}
              </MenuItem>
            ))}
          </MenuList>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};
